var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMarketplaceWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3878_7085)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M4.0625 22.9531V18.8906C4.0625 17.7734 4.97656 16.8594 6.09375 16.8594H3.04688C1.92969 16.8594 1.01562 17.7734 1.01562 18.8906V22.9531C1.01562 24.0703 1.92969 24.9844 3.04688 24.9844H6.09375C4.97656 24.9844 4.0625 24.0703 4.0625 22.9531Z",
    fill: "url(#paint0_linear_3878_7085)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0312 21.9375H10.9688C10.4078 21.9375 9.95312 21.4828 9.95312 20.9219C9.95312 20.3609 10.4078 19.9062 10.9688 19.9062H15.0312C15.5922 19.9062 16.0469 20.3609 16.0469 20.9219C16.0469 21.4828 15.5922 21.9375 15.0312 21.9375Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9531 15.8438H3.04688C1.36683 15.8438 0 17.2106 0 18.8906V22.9531C0 24.6332 1.36683 26 3.04688 26H22.9531C24.6332 26 26 24.6332 26 22.9531V18.8906C26 17.2106 24.6332 15.8438 22.9531 15.8438ZM23.9688 22.9531C23.9688 23.5131 23.5131 23.9688 22.9531 23.9688H3.04688C2.48686 23.9688 2.03125 23.5131 2.03125 22.9531V18.8906C2.03125 18.3306 2.48686 17.875 3.04688 17.875H22.9531C23.5131 17.875 23.9688 18.3306 23.9688 18.8906V22.9531ZM2.03125 9.60969V12.7969C2.03125 13.3578 2.48595 13.8125 3.04688 13.8125C3.6078 13.8125 4.0625 13.3578 4.0625 12.7969V10.1562C5.24672 10.1562 6.31399 9.64666 7.05722 8.83558C7.75338 9.65565 8.77561 10.1562 9.95312 10.1562C11.1656 10.1562 12.255 9.62162 13 8.77657C13.745 9.62162 14.8344 10.1562 16.0469 10.1562C17.2244 10.1562 18.2466 9.65565 18.9428 8.83558C19.686 9.64666 20.7533 10.1562 21.9375 10.1562V12.7969C21.9375 13.3578 22.3922 13.8125 22.9531 13.8125C23.5141 13.8125 23.9688 13.3578 23.9688 12.7969V9.60969C25.1818 8.90617 26 7.59413 26 6.09375C26 5.20757 25.7196 4.36526 25.189 3.65798L23.3604 1.21997C22.7876 0.456066 21.876 0 20.9219 0H5.07812C4.124 0 3.21242 0.456066 2.63961 1.21987L0.811078 3.65793C0.280414 4.36526 0 5.20757 0 6.09375C0 7.59413 0.818187 8.90617 2.03125 9.60969ZM2.43603 4.87673L4.26471 2.43857C4.4588 2.17973 4.75531 2.03125 5.07812 2.03125H20.9219C21.2447 2.03125 21.5412 2.17973 21.7354 2.43867L23.5641 4.87678C23.8288 5.22976 23.9688 5.65058 23.9688 6.09375C23.9688 7.21378 23.0576 8.125 21.9376 8.125C20.8175 8.125 19.9063 7.21378 19.9063 6.09375C19.9063 5.53282 19.4516 5.07812 18.8907 5.07812C18.3297 5.07812 17.8751 5.53282 17.8751 6.09375C17.8751 7.10313 17.2471 8.125 16.0469 8.125C14.9269 8.125 14.0157 7.21378 14.0157 6.09375C14.0157 5.53282 13.561 5.07812 13.0001 5.07812C12.4391 5.07812 11.9844 5.53282 11.9844 6.09375C11.9844 7.21378 11.0732 8.125 9.95318 8.125C8.75301 8.125 8.12505 7.10313 8.12505 6.09375C8.12505 5.53282 7.67036 5.07812 7.10943 5.07812C6.5485 5.07812 6.0938 5.53282 6.0938 6.09375C6.0938 7.21378 5.18258 8.125 4.06255 8.125C2.94252 8.125 2.0313 7.21378 2.0313 6.09375C2.03125 5.65058 2.1712 5.22976 2.43603 4.87673Z",
    fill: "url(#paint1_linear_3878_7085)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3878_7085",
    x1: 1.01562,
    y1: 16.8594,
    x2: 7.95051,
    y2: 22.8265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3878_7085",
    x1: 0,
    y1: 0,
    x2: 21.3428,
    y2: 29.3829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3878_7085"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketplaceWhite);
export default __webpack_public_path__ + "static/media/marketplaceWhite.a8abb8fc707992c9ab88c2dbbe28963a.svg";
export { ForwardRef as ReactComponent };